export const defaultProps = {
  color: 'black',
  padding: '4',
  borderRadius: '15',
  borderWidth: '1',
  borderColor: 'gray.300',
  _focus: {
    borderColor: 'blue.400',
  },
  fontSize: 'lg',
};
